import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/prototype'
import './core/directives/directive'
import './assets/less/index.less'
import './assets/advFonts/style.css'

// import Vant from 'vant'
import 'vant/lib/index.less'

// Vue.use(Vant);
Vue.config.productionTip = false
import {
	Button,
	NavBar,
	Tabbar,
	TabbarItem,
	PullRefresh,
	List,
	Toast,
	Popup,
	Dialog,
	Field,
	Picker,
	Area,
	Loading
} from 'vant'
Vue.use(Button)
	.use(NavBar)
	.use(Tabbar)
	.use(TabbarItem)
	.use(PullRefresh)
	.use(List)
	.use(Toast)
	.use(Popup)
	.use(Dialog)
	.use(Field)
	.use(Picker)
	.use(Area)
	.use(Loading)

window.addEventListener(
	'popstate',
	function(e) {
		router.isBack = true
	},
	false
)

let chcp = window.chcp

if (chcp) {
	chcp.fetchUpdate((error, data) => {
		if (!error) {
			if (error.code === -2) {
				var dialogMessage = '发现新版本，为避免影响使用请更新'
				alert(dialogMessage)
				chcp.requestApplicationUpdate(dialogMessage, null, null)
			}
		} else {
			alert('当前是最新版本')
		}
	})
}

new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
})
